import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';


import ResponseTimeGeneralSimplified from './ResponseTimeGeneralSimplified';
import ResponseTimeForStepSimplified from './ResponseTimeForStepSimplified'
import ResponseTimeForNodeSimplified from './ResponseTimeForNodeSimplified'
import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';


import { withRouter } from 'react-router-dom';


// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import RefreshIcon from '@material-ui/icons/Refresh';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';

// Material components
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import HelpIcon from '@material-ui/icons/Help';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';

import PerfectScrollbar from 'react-perfect-scrollbar';

// Palette
import palette from 'theme/palette';


// Component styles
import styles from './styles';

import moment from 'moment-timezone'
import 'moment/locale/es'
import { withTranslation } from 'react-i18next'
moment.locale('es')


class ResponseTimeSimplified extends Component {

    constructor(props) {
        super(props);
        this.handleResponseClick = this.handleResponseClick.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.handleNodeClick = this.handleNodeClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
    this.state = {
            typeGraph: this.props.typeGraph,
            period: this.props.params.period,
            steps: this.props.isSecondObjective ? this.props.params.objectiveSecond.Pasos : this.props.params.objectiveFirst.Pasos,
            step: this.props.isSecondObjective && this.props.params.objectiveSecond !== 0 ? this.props.params.objectiveSecond.Pasos[0]?.id_paso : this.props.params.objectiveFirst.Pasos[0]?.id_paso,
            isForStep: false,
            nameStep: null,
            namePeriod: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.isSecondObjective ? this.props.params.objectiveSecond.objetivo_id : this.props.params.objectiveFirst.objetivo_id,
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            // nameGraph and detalleGraph will be localized in render using i18n keys
            nameGraph: [' Consolidado', ' Detalle por Paso', ' Detalle por Monitor'],
            typePeriod: this.props.params.typePeriod,
            nameSelectStep: this.props.isSecondObjective && this.props.params.objectiveSecond !== 0 ? this.props.params.objectiveSecond.Pasos[0]?.nombre_paso : this.props.params.objectiveFirst.Pasos[0]?.nombre_paso,
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: false,
            date: new Date(),
            dateMoment: (moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
            isOneHour: false,
            detalleGraph:[' Corresponde a los tiempos de respuestas consolidados (promedio desde todos los ISPs) del objetivo durante el período y horario seleccionado.', 
                        ' Corresponde a la información estadística de los tiempos de respuestas del objetivo, separado por paso, durante el período y horario seleccionado.',
                        ' Corresponde a los tiempos de respuesta del objetivo, para cada ISP desde donde se monitorea el objetivo, separado por paso, durante el período y horario seleccionado.'],
            intervalId: null,
        };
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
     }
     
     tick() {
         if(this.state.checkedA===true){
             this.setState({
             date: new Date(),
             dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a"))
             });
         }
     }

    handleResponseClick() {
        if(this.props.isSecondObjective){
            this.props.handleTypegraph('typegraphResponseSecond', 0)
        }else {
            this.props.handleTypegraph('typegraphResponseFirst', 0)
        }
        this.setState({
            typeGraph: 0,
            isForStep: false,
            isLastEvent: false,
            responseTimeGraphEl: null,
            //nameSelectStep: "Seleccione Paso",
            isRefresh: false,
            isOneHour: false,
        });
    }

    handleStepClick() {
        if(this.props.isSecondObjective){
            this.props.handleTypegraph('typegraphResponseSecond', 1)
        }else {
            this.props.handleTypegraph('typegraphResponseFirst', 1)
        }
        let step = 0
        let nameSelectStep = null
        let isFull = false
        const {steps} = this.state
        Object.values(steps).map(i => { 
            if (!isFull){
                step = i.id_paso
                isFull = true
                nameSelectStep = i.nombre_paso
            }
        })
        this.setState({
            typeGraph: 1,
            isForStep: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
            step: step,
            nameSelectStep: nameSelectStep
        });
    }

    handleNodeClick() {
        if(this.props.isSecondObjective){
            this.props.handleTypegraph('typegraphResponseSecond', 2)
        }else {
            this.props.handleTypegraph('typegraphResponseFirst', 2)
        }
        let step = 0
        let nameSelectStep = null
        let isFull = false
        const {steps} = this.state
        Object.values(steps).map(i => { 
            if (!isFull){
                step = i.id_paso
                isFull = true
                nameSelectStep = i.nombre_paso
            }
        })
        this.setState({
            typeGraph: 2,
            isForStep: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
            //step: step,
            //nameSelectStep: nameSelectStep
        });

    }

    
    handleNextStepClick = event => {
        const newSelectStep = event.currentTarget.name
        const newStep = event.currentTarget.id
        if (this.state.step !== newStep) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                step: newStep,
                isLastEvent: false,
                extendEl: null,
                nameSelectStep: newSelectStep,
                isRefresh: false
            })
        }
    }
    handleInfo(props, step) {
        let oldDate = new Date(props.x)
        let year = oldDate.getUTCFullYear()
        let month = oldDate.getUTCMonth()
        let day = oldDate.getUTCDate()
        let hours = oldDate.getUTCHours()
        let minutes = oldDate.getUTCMinutes()
        let seconds = oldDate.getUTCSeconds()

        let newDate = new Date(year, (month), day, hours, minutes, seconds)
        this.setState({
            nameStep: step,
            x: newDate.toLocaleString([], {hour12: false }),
            y: props.y
        })
    }


    handleFirstInfo(props) {
        let oldDate = new Date(props.x)
        let year = oldDate.getUTCFullYear()
        let month = oldDate.getUTCMonth()
        let day = oldDate.getUTCDate()
        let hours = oldDate.getUTCHours()
        let minutes = oldDate.getUTCMinutes()
        let seconds = oldDate.getUTCSeconds()
        let newDate = new Date(year, (month), day, hours, minutes, seconds)
        if (!this.state.isLastEvent && props.name !== null) {
            this.setState({
                nameStep: props.name,
                x: newDate.toLocaleString([], {hour12: false }),
                y: props.y,
                namePeriod: props.namePeriod,
                isLastEvent: true
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment: props,
            isRefresh: false
        })
    }

    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };

    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };

    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };

    handleRefresh = event => {
        this.setState({
            isRefresh: true,
            settingsEl: null,
        })
    }

    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };
    handleChange = name=>event => {
        this.setState({ 
            checkedA: event.target.checked 
        });
        if (event.target.checked) {
            const newInterval = setInterval(
                () => this.tick(),
                300000
              );
            this.setState({intervalId: newInterval});
        } else {
            clearInterval(this.state.intervalId)
        }
      };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isSecondObjective === true){
            if (prevProps.params.objectiveSecond.objetivo_id !== this.props.params.objectiveSecond.objetivo_id 
                || prevProps.extendView !== this.props.extendView
                || prevProps.params.period !== this.props.params.period
                || prevProps.params.date !== this.props.params.date) {
                    //this.onLayoutChange()
                    this.setState({
                        typeGraph: this.props.typeGraph,
                        period: this.props.params.period,
                        step: this.state.step,
                        steps: this.props.params.objectiveSecond.Pasos,
                        //isForStep: false,
                        nameStep: null,
                        x: null,
                        y: null,
                        isLastEvent: false,
                        objetive: this.props.params.objectiveSecond.objetivo_id,
                        periodEl: null,
                        date: this.props.params.date
                    })
            }
        } else{
            if (prevProps.params.objectiveFirst.objetivo_id !== this.props.params.objectiveFirst.objetivo_id 
                || prevProps.extendView !== this.props.extendView
                || prevProps.params.period !== this.props.params.period
                || prevProps.params.date !== this.props.params.date) {
                    //this.onLayoutChange()
                    this.setState({
                        typeGraph: this.props.typeGraph,
                        period: this.props.params.period,
                        step: this.state.step,
                        steps: this.props.params.objectiveFirst.Pasos,
                        //isForStep: false,
                        nameStep: null,
                        x: null,
                        y: null,
                        isLastEvent: false,
                        objetive: this.props.params.objectiveFirst.objetivo_id,
                        periodEl: null,
                        date: this.props.params.date
                    })
            }
        }
    }

    render() {
        const { classes, className, params, isSecondObjective, ...rest } = this.props;
        const { typeGraph, period, isForStep, step, x, y, nameStep, statePeriod, isStatePeriod, responseTimeGraphEl, 
            periodEl, /* nameGraph, */ extendEl, nameSelectStep, settingsEl, isRefresh,isInfo, /* detalleGraph, */ 
            date, steps} = this.state;
        const { t } = this.props;

        // localized arrays (use locale keys; fallbacks to original spanish text)
        const localizedNameGraph = [
            t('graph.consolidated-response-time.select.option.consolidated') || 'Consolidado',
            t('graph.consolidated-response-time.select.option.by-step') || 'Paso',
            t('graph.consolidated-response-time.select.option.isp') || 'ISP'
        ];
        const localizedDetalleGraph = [
            t('graph.consolidated-response-time.info.tooltip.description') || ' Corresponde a los tiempos de respuestas consolidados (promedio desde todos los ISPs) del objetivo durante el período y horario seleccionado.',
            t('fav-boards.compare-objectives.about.text-9') || ' Corresponde a la información estadística de los tiempos de respuestas del objetivo, separado por paso, durante el período y horario seleccionado.',
            t('fav-boards.compare-objectives.about.text-11') || ' Corresponde a los tiempos de respuesta del objetivo, para cada ISP desde donde se monitorea el objetivo, separado por paso, durante el período y horario seleccionado.'
        ];
        let buttonResponse;
        let buttonStep;
        let buttonNode;
        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showPeriodEl = Boolean(periodEl);
        const showIsInfo = Boolean(isInfo);
        const showExtendEl = Boolean(extendEl);
        const showSettingsEl = Boolean(settingsEl);

    buttonResponse = <ResponseButton onClick={this.handleResponseClick} t={t} />;
    buttonStep = <StepButton onClick={this.handleStepClick} t={t} />;
    buttonNode = <NodeButton onClick={this.handleNodeClick} t={t} />;

        const rootClassName = classNames(classes.root, className);

        return (
            <Portlet
                /*  {...rest} */
                className={rootClassName}
                style={{height: '100%'}}
            >
                <PortletHeader className={classes.header}
                >
                    <PortletLabel
                        /*  icon={<DevicesIcon />} */
                        variant="h6"
                        title={this.props.title + ' ' + localizedNameGraph[typeGraph]}
                        
                    />

                    <PortletToolbar>
                        <IconButton
                            //className={classes.refreshButton}
                            //variant="text"
                            onClick={this.handleShowSettings}
                        >
                            <SettingsOutlinedIcon />
                            
                        </IconButton>
                        <Popover
                            anchorEl={settingsEl}
                            
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            onClose={this.handleCloseSettings}
                            open={showSettingsEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}>
                            <IconButton
                                className={classes.refreshButton}
                                variant="text"
                                onClick={this.handleRefresh}
                                onClose={this.handleCloseSettings}
                            >
                                <div>
                                <RefreshIcon color="infoIcon" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('text.update') || 'Actualizar'}</Typography>
                                </div>
                            </IconButton>
                            <IconButton
                                    onClick={this.handleShowIsInfo}
                                    onClose={this.handleCloseIsInfo}
                                >
                                    <div>
                                        <HelpIcon color="infoIcon"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('graph.consolidated-response-time.info.text') || 'Información'}</Typography>
                                    </div>
                                </IconButton>
                                    <Popover
                                    anchorEl={isInfo}
                                    open={showIsInfo}
                                    onClose={this.handleCloseIsInfo}
                                    >
                                    <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{localizedDetalleGraph[typeGraph]}</PortletContent>
                                </Popover>
                                <Tooltip title={t('text.auto-update') || 'Actualización automática'}>
                                    <div style={{textAlign:"center"}}>
                                        <Switch
                                            checked={this.state.checkedA}
                                            onChange={this.handleChange('checkedA')}
                                            value="checkedA"
                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            color='primary'
                                        />
                                    </div>
                                </Tooltip>

                        </Popover>
                        <Button
                            style={{color:"#353535"}}
                            variant="text"
                            onClick={this.handleShowResponseTimeGraph}
                        >
                            {t('graph.consolidated-response-time.select.name') || 'Gráficos'} <ArrowDropDownIcon />
                        </Button>
                        <Popover
                            anchorEl={responseTimeGraphEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleCloseResponseTimeGraph}
                            open={showResponseTimeGraphEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <div>
                                        {buttonResponse}
                                        {buttonStep}
                                        {buttonNode}
                            </div>
                        </Popover>
                    </PortletToolbar>
                </PortletHeader>
                <PortletContent className={classes.content}>
                    <Grid
                        container
                        spacing={10}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            xl={12}
                            >
                            <PerfectScrollbar>
                                <div >
                                {period == 'c' ?
                                            <div >
                                            <Typography   color="textSecondary" gutterBottom>
                                                desde {statePeriod.startDate.toISOString().substring(0, 10)} hasta {statePeriod.endDate.toISOString().substring(0, 10)}
                                            </Typography>
                                        </div>
                                        
                                    : null}
                                    {<Graph
                                        typeGraph={typeGraph}
                                        period={period}
                                        step={step}
                                        onInfo={this.handleInfo}
                                        onFirstInfo={this.handleFirstInfo}
                                        statePeriod={statePeriod}
                                        isStatePeriod={isStatePeriod}
                                        isRefresh={isRefresh}
                                        date={date}
                                        onDateMoment={this.handleDateMoment}
                                        objective={isSecondObjective ? params.objectiveSecond : params.objectiveFirst}/>}                            
                                </div>
                                <div>
                                    <Typography variant="h4" style={{fontSize:'13px',float:'left', paddingLeft:'5px', color:'#66788A'}}>
                                        {/*<h5>{namePeriod}</h5>*/}
                                        <h5>{nameStep}</h5>
                                        <h1>{y}(s)</h1>
                                        <h5>{x}</h5>
                                    </Typography>
                                </div>
                            </PerfectScrollbar>
                        </Grid>
                    </Grid>     
                </PortletContent>
                {isForStep ?
                <PortletFooter className={classes.portletFooter}>
                            <div>
                                <Button
                                    color="primary"
                                    variant="text"
                                    onClick={this.handleShowExtend}
                                >
                                    {nameSelectStep}
                                    <ArrowRightIcon />
                                </Button>
                                {<Popover
                                    anchorEl={extendEl}
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'right'
                                    }}
                                    onClose={this.handleCloseExtend}
                                    open={showExtendEl}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left'
                                    }}>
                                    <div >
                                        {isForStep ? <div className="row1">
                                                        <List component="div">
                                                            {Object.values(steps).map(i => (
                                                                <ListItem
                                                                    className={classes.listItem}
                                                                    component="div"
                                                                >
                                                                    <Button id={i.id_paso} name={i.nombre_paso} onClick={(event) => this.handleNextStepClick(event)}>{i.nombre_paso}</Button> 
                                                                </ListItem>))}
                                                        </List>
                                                    </div> 
                                        : <div style={{paddingLeft:'5px',paddingRight:'5px',paddingTop:'5px', fontFamily:'Roboto'}}> {t('response-time.no-more-information') || 'No hay mas información que mostrar'}</div>}
                                    </div>
                                </Popover>}
                            </div> 
                </PortletFooter>
                :  null}
            </Portlet>
        )
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <ResponseTimeGeneralSimplified params={props} />;
    }
    if (typeGraph === 1) {
        return <ResponseTimeForStepSimplified params={props} />;
    }
    if (typeGraph === 2) {
        return <ResponseTimeForNodeSimplified params={props} />;
    }
}

function ResponseButton(props) {
    return (
        <Button variant="text" onClick={props.onClick}>
            { (props.t && props.t('graph.consolidated-response-time.select.option.consolidated')) || 'Consolidado' }
      </Button>
    );
}

function StepButton(props) {
    return (
        <Button variant="text" onClick={props.onClick}>
            { (props.t && props.t('graph.consolidated-response-time.select.option.by-step')) || 'Paso' }
      </Button>
    );
}

function NodeButton(props) {
    return (
        <Button variant="text" onClick={props.onClick}>
            { (props.t && props.t('graph.consolidated-response-time.select.option.isp')) || 'ISP' }
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles), withTranslation())(ResponseTimeSimplified);